import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Logoimg from "../images/logo.png"
import $ from 'jquery'
import countryToCurrency from 'country-to-currency'

export default function Signup() {
    const [country, setCountry] = useState("");
    const [currency, setCurrency] = useState("");
    const [showLoader, setShowLoader] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {

        fetch("country.php")
            .then(res => res.json())
            .then(data => {

                if (data.success) {
                    setCountry(data.country);
                    const currency = countryToCurrency[data.country_code]; // INR
                    setCurrency(currency);
                }

            });

    }, []);

    function signupnow() {
        setShowLoader(true);
        var position = 'Super admin'
        var status = 'not_complete';
        var useremail = document.getElementById('uemail').value;
        var userpass = document.getElementById('upass').value;
        var cpass = document.getElementById('cupass').value;
        var company_name = document.getElementById('company_name').value;
        var fname = document.getElementById('fname').value;
        var lname = document.getElementById('lname').value;
        var countryname = document.getElementById('countryname').value;
        var currencyvalue = document.getElementById('usercurrency').value;
        if (userpass == cpass) {
            if (useremail == '') {
                document.getElementById('uemail').classList.add('highlight_box')
            } else if (userpass == '') {
                document.getElementById('upass').classList.add('highlight_box')
            } else if (company_name == '') {
                document.getElementById('company_name').classList.add('highlight_box')
            } else if (fname == '') {
                document.getElementById('fname').classList.add('highlight_box')
            } else if (lname == '') {
                document.getElementById('lname').classList.add('highlight_box')
            } else {
                var obj = {
                    mem_email: useremail,
                    password: userpass,
                    mem_role: position,
                    mem_account_status: status,
                    company_name: company_name,
                    fname: fname,
                    lname: lname,
                    expertise: 'Adminstrator',
                    mem_skills: '',
                    mem_com_id: '',
                    activation: 'actaive',
                    country_name: countryname,
                    currencyval: currencyvalue,
                    max_member : '2'
                }

                $.ajax({
                    type: 'POST',
                    url: 'adminUserSignUp.php',
                    data: obj,
                    cache: false,
                    success: function (result) {
                        console.log(result);

                        if (result != 'fail') {
                            var luid = result.trim();

                            var firstname = fname;
                            var lastname = lname;
                            var membername = firstname + ' ' + lastname;
                            var emailval = useremail;
                            var mem_position = position;
                            var mem_permission = 'All';
                            var mem_company_name = company_name;
                            var mem_company_id = luid

                            localStorage.setItem('membername', membername);
                            localStorage.setItem('useremail', emailval);
                            localStorage.setItem('mem_permission', mem_permission);
                            localStorage.setItem('user_position', mem_position);
                            localStorage.setItem('mem_company_name', mem_company_name);
                            localStorage.setItem('mem_company_id', mem_company_id);
                            localStorage.setItem('member_currency', currencyvalue);
                            localStorage.setItem('member_country', countryname);
                            localStorage.setItem('membership_type', 'free');
                            localStorage.setItem('prevmembership_type', 'free');
                            localStorage.setItem('max_member', '2');
                            saveATmember(luid, company_name, fname, lname, position);
                            //window.location.href = 'signin.php';
                        } else if (result == 'Mail Exist') {
                            alert('Your email id is already in use.')
                            setShowLoader(false);
                        } else {
                            alert('Cannot create account. Please try once again.')
                            setShowLoader(false);
                        }
                    },
                });
            }
        } else {
            showAlert('Password not matched. Please check your password')
            setShowLoader(false);
        }
    }


    function saveATmember(comid, comname, fname, lname) {
        const allowedTypes = [
            'image/jpeg',
            'image/jpg',
            'image/png',
            'image/gif'
        ];
        const fileInput = document.getElementById('comlogo');

        if (fileInput.files.length < 1) {
            showAlert('Please select your company logo');
            setShowLoader(false);
        } else {
            const file = fileInput.files[0];
            console.log(file.type)
            if (!allowedTypes.includes(file.type)) {
                showAlert("Please upload only JPG, JPEG, PNG or GIF images.");
                fileInput.value = ""; // Clear the invalid file
                setShowLoader(false);

            } else {
                const formData = new FormData();
                formData.append('mem_account_status', 'not_complete');
                formData.append('mem_email', document.getElementById('uemail').value);
                formData.append('password', document.getElementById('upass').value);
                formData.append('country', '');
                formData.append('expertise', 'Management');
                formData.append('mem_skills', 'Management');
                formData.append('mem_com_id', comid);
                formData.append('mem_role', 'Super Admin');
                formData.append('company_name', comname);
                formData.append('fname', fname);
                formData.append('lname', lname);
                formData.append('activation', 'true');
                formData.append('memberimg', 'profile_imgs/no-image-icon-32.jpg');
                // ✅ add image
                if (fileInput.files.length > 0) {
                    const file = fileInput.files[0];
                    formData.append('companyimage', file);
                } else {
                    formData.append('companyimage', 'profile_imgs/no-image-icon-32.jpg');
                }
                $.ajax({
                    type: 'POST',
                    url: 'usersignup.php',
                    data: formData,
                    processData: false,   // ✳️ important
                    contentType: false,   // ✳️ important
                    cache: false,
                    success: function (result) {
                        console.log(result);
                        if (result !== 'fail') {
                            getUserData(result)
                            //navigate('/add_member');
                        } else {
                            showAlert('Cannot create account. Please try again.');
                            setShowLoader(false);
                        }
                    }
                });
            }
        }
    }

    function getUserData(uid) {
        var obj = {
            uid: uid
        }
        console.log(obj);
        $.ajax({
            type: 'POST',
            url: 'getUserDataAfterSignup.php',
            data: obj,
            cache: false,
            success: function (result) {
                console.log(result);
                if (result.trim() != 'fail') {
                    var arr = result.split('|');
                    var firstname = arr[0].trim();
                    var lastname = arr[1].trim();
                    var membername = firstname + ' ' + lastname;
                    var emailval = arr[2];
                    var LUID = arr[3];
                    var mem_position = arr[4];
                    var mem_permission = arr[5];
                    var mem_company_name = arr[6];
                    var mem_company_id = arr[7];
                    var mem_profile_img = arr[8];
                    var mem_company_logo = arr[9];
                    localStorage.setItem('member_id', LUID);
                    localStorage.setItem('memberFirstname', firstname);
                    localStorage.setItem('membername', membername);
                    localStorage.setItem('useremail', emailval);
                    localStorage.setItem('mem_permission', mem_permission);
                    localStorage.setItem('user_position', mem_position);
                    localStorage.setItem('mem_company_name', mem_company_name);
                    localStorage.setItem('mem_company_id', mem_company_id);
                    localStorage.setItem('memberimg', mem_profile_img);
                    localStorage.setItem('companylogo', mem_company_logo);
                    // navigate('/add_member');
                    addToComapnyDetails(membername, emailval, mem_company_id, mem_company_name, LUID)
                } else {
                    alert('Cannot login. Please try once again.')
                    setShowLoader(false);
                }
            },
        });
    }


    function addToComapnyDetails(membername, emailval, mem_company_id, mem_company_name, LUID) {
        const formData = new FormData();
        formData.append('ceo_name', membername);
        formData.append('business_email', emailval);
        formData.append('com_id', mem_company_id);
        formData.append('registered_name', mem_company_name);
        // 👆 make sure memberId exists (from session / JS variable)

        fetch('insertCompanyDetails.php', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                if (data.status === 'success') {
                    // navigate('/add_member');
                    addDefaultroles(mem_company_id, LUID);
                } else {
                    showAlert(data.message);
                }
            })
            .catch(err => {
                console.error(err);
                showAlert("Cannot save company details");
                setShowLoader(false);
            });
    }

    function addDefaultroles(com_id, mem_id) {
        const formData = new FormData();
        formData.append('company_id', com_id);
        formData.append('user_id', mem_id);
        // 👆 make sure memberId exists (from session / JS variable)

        fetch('SavedefaultRole.php', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                console.log('SavedefaultRole')
                console.log(data)
                if (data.status === 'success') {
                    // navigate('/add_member');
                    updateSuperadminPermission()
                } else {
                    showAlert(data.message);
                    setShowLoader(false);
                }
            })
            .catch(err => {
                console.error(err);
                showAlert("Cannot add default roles");
                setShowLoader(false);
            });
    }

    function updateSuperadminPermission() {
        let com_id = localStorage.getItem('mem_company_id');
        let user_id = localStorage.getItem('member_id');
        const formData = new FormData();
        formData.append('company_id', com_id);
        formData.append('user_id', user_id);
        // 👆 make sure memberId exists (from session / JS variable)

        fetch('updatePermission.php', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                console.log('updatePermission: ' + data)
                if (data.status === 'success') {
                    getPermission();
                } else {
                    showAlert(data.message);
                    setShowLoader(false);
                }
            })
            .catch(err => {
                console.error(err);
                showAlert("Cannot add default roles");
                setShowLoader(false);
            });

    }

    function getPermission() {
        $.ajax({
            type: 'POST',
            url: 'getUserPermissions.php',
            success: function (response) {
                console.log(response);
                //const data = JSON.parse(response);
                const data = response;

                if (data.status === 'success') {
                    localStorage.setItem(
                        'user_permissions',
                        JSON.stringify(data.permissions)
                    );
                    navigate('/add_member');
                    setShowLoader(false);
                } else {
                    showAlert('Not loged in yet.');
                    setShowLoader(false);
                }
            }
        });
    }


    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }

    return (
        <div>
            <div className="signinbody signinback">
                <div className="signinbox extra_width_signup">
                    <div className="logoholder">
                        <Link to="/"><img src={Logoimg} alt="Logo" /></Link>
                    </div>
                    <div className="logbox hig600 narrowpadding">
                       
                        <h3> Sign Up With Email</h3>

                        <div className="formfieldbox">
                            <label>First Name</label>
                            <input type="text" id="fname" placeholder="First Name**" />
                        </div>
                        <div className="formfieldbox">
                            <label>Last Name</label>
                            <input type="text" id="lname" placeholder="Last Name**" />
                        </div>
                        <div className="formfieldbox">
                            <label>Company Name</label>
                            <input type="text" id="company_name" placeholder="Company Name**" />
                        </div>
                        <div className="formfieldbox">
                            <label>Your Email</label>
                            <input type="email" id="uemail" placeholder="Your Email**" />
                        </div>
                        <div className="formfieldbox">
                            <label>Your Country</label>
                            <input type="text" value={country} name="countryname" id="countryname" readOnly />
                        </div>
                        <div className="formfieldbox">
                            <label>Your Currency</label>
                            <input type="text" value={currency} name="usercurrency" id="usercurrency" readOnly />
                        </div>
                        <div className="formfieldbox">
                            <label>Your Password</label>
                            <input type="password" id="upass" placeholder="Your Password**" />
                        </div>
                        <div className="formfieldbox">
                            <label>Confirm Password</label>
                            <input type="password" id="cupass" placeholder="Confirm Your Password**" />
                        </div>
                        <div className="formfieldbox">
                            <label>Upload Your Company Logo</label>
                            <input type="file" id="comlogo" accept="image/*" />
                            <p>Only JPG, JPEG, GIF, PNG file</p>
                        </div>
                        <div className="formbtnbox">
                            <input type="button" id="sub" value="Sign in" onClick={signupnow} />
                        </div>
                        <p>Have an account? <Link to="/">Login now</Link></p>
                    </div>
                   
                </div>
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>

            {showLoader && (
                <div className='loaderpop'>
                    <div className='loader_inner'>
                        <p>Please wait...We are working</p>
                    </div>
                </div>
            )}
        </div>
    )
}
